import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WizardComponent } from './features/wizardcomponent/wizard.component';

const routes: Routes = [
  {
    path: ':aliasProducto', component: WizardComponent
  },
  {
    path: '', component: WizardComponent
  }
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
